/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-02-11 11:11:06
 * @LastEditors: zcy
 * @LastEditTime: 2022-03-17 14:12:32
 */
/*
防抖
详细解释见https://blog.csdn.net/weixin_41957432/article/details/109515779
*/

import Vue from 'vue';

function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result;

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;
        // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            }
        }
    };

    return function (...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}

export default () => {
    // 点击按钮节流
    Vue.directive('debounce', {
        /**
         * 绑定
         * @param el 元素
         * @param binding  binding的值为指令绑定的值,binding中有哪些值，可以去vue官网中查看自定义指令
         * 使用: 
         * 参数(毫秒):timing = 1000;
         * 传参: v-debounce="[() => doSubmit(), timing]"
         * 不传参: v-debounce="() => doSubmit()"
         */
        bind: function (el, binding) {
            // 绑定的值为el，和binding
            // binding的值为指令绑定的值,binding中有哪些值，可以去vue官网中查看自定义指令
            let execFunc
            // 在函数传参与不传参调用的时候，打印出来的binding.value是不同的
            // 打印binding.value可以帮助理解为什么有传参和不传参的区别
            if (binding.value instanceof Array) {
                // 函数传参
                const [func, time = 500] = binding.value
                execFunc = debounce(func, time, true)
            } else {
                // 函数不传参
                execFunc = debounce(binding.value, 500, true)
            }
            el.addEventListener('click', execFunc)
        }

    })
}